import DialogManager from "@/utils/DialogManager";
import {BoardTemplate} from "@/server/com/silkplm/engine/model/BoardTemplate";
import Rpc from "@/Rpc";
import dialogManager from "@/utils/DialogManager";

export async function boardPrintout(listInstance) {
    /**
     * @type {StreamingEngine|null|*}
     */
    let showMultiSelect = listInstance.$data.showMultiSelect;
    let streamingEngine = listInstance.streamingEngine;
    let singleEntity = null;
    if (!showMultiSelect) {
        let selectionLocal = listInstance.$data.selectionLocal;
        if (selectionLocal?.length) {
            singleEntity = selectionLocal[0];
        }
    }
    let rowsCount = listInstance.selectionSize;

    if (rowsCount > 200) {
        await DialogManager.info($tr("boardPrintouts.tooManyRecords", "Too many records selected"));
        return
    }

    let formats = await BoardTemplate.list();

    if (streamingEngine == null) {
        await dialogManager.info($tr("attention", "Attention"),
            $tr("boardPrintouts",
                "To perform the operation, you need to enable the Experimental streaming lists flag in the Configuration or Streaming Data Load in Settings My Account."));
        return;
    }

    let format = await DialogManager.selectInCombo($tr("boardPrintouts.chooseFormat", "Choose format"), formats.map(i => {
        return {'value': i, 'text': i.name}
    }));

    if (!format) {
        return;
    }

    let selection = streamingEngine.getStreamSelection();
    if (!showMultiSelect && singleEntity) {
        selection.includedViewIds = [singleEntity.__full_id__];
    }
    await Rpc.Printouts.scheduleBoardPrintoutJob(format.id, selection);
}